namespace Nobox.Administration {
    export namespace PermissionKeys {
        export const General = "";
        export const Security = "Security";
        export const Management = "Administration:Management";
        export const Translation = "Administration:Translation";
        export const Tenant = "Administration:Tenants";
        export const Tenants = "Tenants";
        export const Exception = "Administration:Exception";

        namespace Company {
            export const Delete = "Company:Delete";
            export const Modify = "Company:Modify";
            export const View = "Company:View";
            export const Page = "Company:Page";
        }

        namespace User {
            export const Delete = "User:Delete";
            export const Modify = "User:Modify";
            export const View = "User:View";
            export const Page = "User:Page";
        }

        namespace Language {
            export const Delete = "Language:Delete";
            export const Modify = "Language:Modify";
            export const View = "Language:View";
            export const Page = "Language:Page";
        }
    }
}
